import CompatsTitle from './compats-title';

export default CompatsTitle;
